import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colorAppError } from 'common/styles/colors';

const SocialRsvpRequiredLabel = styled.p`
    margin-top: 1rem;
    color: ${(props) => (props.requiredError ? colorAppError : '')};
`;

const SocialRsvpRequiredMessage = ({ requiredMessage, requiredError }) => (
    <SocialRsvpRequiredLabel role="alert" aria-label={requiredMessage} requiredError={requiredError}>
        {requiredMessage}
    </SocialRsvpRequiredLabel>
);

SocialRsvpRequiredMessage.propTypes = {
    requiredError: PropTypes.bool,
    requiredMessage: PropTypes.string.isRequired,
};

SocialRsvpRequiredMessage.defaultProps = {
    requiredError: false,
};

export default SocialRsvpRequiredMessage;
